
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import PercentBar from '~/components/atoms/PercentBar.vue'
import { Gender } from '~/types/api/result'

export default Vue.extend({
  components: {
    PercentBar,
  },
  props: {
    genderType: {
      type: String,
      required: true,
    },
    gender: {
      type: Object,
      required: true,
    } as PropOptions<Gender>,
  },
  computed: {
    genderTypeClass() {
      return {
        'sexualities--sex': this.genderType === 'sex',
        'sexualities--genderIdentity': this.genderType === 'gender_identity',
        'sexualities--genderExpression': this.genderType === 'gender_expression',
        'sexualities--sexualOrientation': this.genderType === 'sexual_orientation',
        'sexualities--romanticOrientation': this.genderType === 'romantic_orientation',
      }
    },
  },
})
